
document.querySelectorAll(".copy-code-right").forEach(function (copyBtn) {
    copyBtn.addEventListener("click", function () {
      let codeElement = this.closest(".coupan-right-block").querySelector(".copy-code-left");
      if (codeElement) {
        let codeText = codeElement.innerText.trim();
        navigator.clipboard.writeText(codeText).catch(err => {
          console.error("Copy failed", err);
        });
      }
    });
  });

  document.addEventListener("DOMContentLoaded", function () {
  // Copy coupon code
  document.querySelectorAll(".copy-code-right").forEach(function (copyBtn) {
    copyBtn.addEventListener("click", function () {
      let codeElement = this.closest(".coupan-right-block").querySelector(".copy-code-left");
      if (codeElement) {
        let codeText = codeElement.innerText.trim();
        navigator.clipboard.writeText(codeText).catch(err => {
          console.error("Copy failed", err);
        });
      }
    });
  });

  // Close bar
  document.querySelectorAll(".discount-bar-close-icon").forEach(function (closeBtn) {
    closeBtn.addEventListener("click", function () {
      let bar = this.closest(".coupan-code");
      if (bar) {
        bar.style.display = "none";
      }
    });
  });
});

// master class video play
document.addEventListener("DOMContentLoaded", function() {
  document.querySelectorAll(".masterclass-video").forEach(wrapper => {
    const video = wrapper.querySelector(".custom-video");
    const playBtn = wrapper.querySelector(".play-btn");
    if (!video || !playBtn) return;

    // On button click → play video
    playBtn.addEventListener("click", function() {
      video.classList.add("show");
      video.play();
    });

    // Hide play button whenever video starts playing
    video.addEventListener("play", function() {
      playBtn.style.display = "none";
    });

    // Show play button again when video paused or ended
    ["pause", "ended"].forEach(evt => {
      video.addEventListener(evt, function() {
        video.classList.remove("show");
        playBtn.style.display = "block";
      });
    });
  });

  // master For v2
  document.querySelectorAll(".masterVideoSliderCover .swiper-slide").forEach(slide => {
    const video = slide.querySelector("video");
    const playBtn = slide.querySelector(".playBtnIcon");
    const coverImg = slide.querySelector(".videoCover_img");

    if (!video || !playBtn) return;

    playBtn.addEventListener("click", function () {
      // Pause all other videos before playing this one
      document.querySelectorAll(".masterVideoSliderCover video").forEach(v => {
        if (v !== video && !v.paused) {
          v.pause();
        }
      });

      // Hide play button and cover image permanently for this slide
      playBtn.style.display = "none";
      if (coverImg) coverImg.style.display = "none";

      video.style.display = "block";
      video.play();
    });

    ["pause", "ended"].forEach(evt => {
      video.addEventListener(evt, function () {
        // Show play button again, but NOT cover image
        playBtn.style.display = "block";
      });
    });
  });

});

//audio play 

document.addEventListener("DOMContentLoaded", function () {
  const playSVG = `
    <svg class="icon play-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24">
      <path d="M10.285,2.858a2,2,0,0,1,3.43,0l8.468,14.113A2,2,0,0,1,20.468,20H3.532a2,2,0,0,1-1.715-3.029Z"
        transform="translate(20) rotate(90)" fill="#1a2f4b" />
    </svg>
  `;

  const pauseSVG = `
    <svg class="icon pause-icon" xmlns="http://www.w3.org/2000/svg" width="20" height="24" viewBox="0 0 20 24">
      <rect x="3" y="2" width="5" height="20" fill="#1a2f4b"></rect>
      <rect x="12" y="2" width="5" height="20" fill="#1a2f4b"></rect>
    </svg>
  `;

  const items = document.querySelectorAll(".audio-item");

  items.forEach(item => {
    const button = item.querySelector(".play-btn");
    const audio = item.querySelector("audio");
    const waveform = item.querySelector(".waveform");

    // Ensure button click works even if clicking the SVG
    button.addEventListener("click", function (e) {
      e.preventDefault();

      if (audio.paused) {
        // Pause all other audios
        document.querySelectorAll(".audio-item audio").forEach(a => {
          if (a !== audio) a.pause();
        });
        document.querySelectorAll(".waveform").forEach(w => w.classList.remove("playing"));
        document.querySelectorAll(".play-btn").forEach(b => {
          if (b !== button) b.innerHTML = playSVG;
        });

        // Play current
        audio.play().catch(err => console.log(err)); // catch promise errors
        waveform.classList.add("playing");
        button.innerHTML = pauseSVG;
      } else {
        audio.pause();
        waveform.classList.remove("playing");
        button.innerHTML = playSVG;
      }
    });

    audio.addEventListener("ended", () => {
      waveform.classList.remove("playing");
      button.innerHTML = playSVG;
    });
  });
});

// Faq load more 

document.addEventListener("DOMContentLoaded", function () {
  const showMoreBtn = document.querySelector(".showmore_btn");
  const hiddenFaqs = document.querySelectorAll(".faq-item.hidden");

  if (showMoreBtn) {
    showMoreBtn.addEventListener("click", function () {
      hiddenFaqs.forEach(faq => faq.classList.remove("hidden"));
      showMoreBtn.style.display = "none"; // hide button after showing
    });
  }
});

// blog page load more

document.addEventListener("DOMContentLoaded", function () {
    const loadMoreBtn = document.getElementById("loadMoreBtn");
    const audioItems = document.querySelectorAll(".audio-item.hidden");

    if (loadMoreBtn) {
        loadMoreBtn.addEventListener("click", function () {
            audioItems.forEach(item => item.classList.remove("hidden"));
            this.style.display = "none"; // hide the Load More button
        });
    }

// masterpage video load more btn 

  const loadMoreBtns = document.querySelector(".load-more-btn");
    if (!loadMoreBtns) return;

    loadMoreBtns.addEventListener("click", function () {
      console.log("click!!!");
      document.querySelectorAll(".masterclass-card.hidden").forEach(card => {
        card.classList.remove("hidden");
      });
      loadMoreBtns.style.display = "none"; // button hide after expand
    });

});


// contact form scroll 

 document.addEventListener('DOMContentLoaded', function() {
    // Check if the URL contains a hash
    if (window.location.hash === '#ContactForm') {
      const form = document.querySelector('#ContactForm');
      
      if (form) {
        // Adjust for sticky header height if you have one
        const headerOffset = 100; 
        const elementPosition = form.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }

      // Optional: remove #ContactForm from URL after scrolling
      history.replaceState(null, null, window.location.pathname);
    }
  });

  // scroll a map section 

  document.addEventListener("DOMContentLoaded", function() {
  const scrollLinks = document.querySelectorAll('a.card-scroll');
  const header = document.querySelector('.sticky-header');

  scrollLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();

      const targetId = this.getAttribute('href').substring(1);
      const targetEl = document.getElementById(targetId);
      if (!targetEl) return;

      // Get sticky header height (or 0 if none)
      const headerHeight = header ? header.offsetHeight : 0;

      // Calculate position with offset
      const targetPosition = targetEl.getBoundingClientRect().top + window.pageYOffset - headerHeight - 100;

      window.scrollTo({
        top: targetPosition,
        behavior: 'smooth'
      });
    });
  });
});





// Smooth scroll code
document.addEventListener('DOMContentLoaded', () => {
  const OFFSET = 100; // Top offset in px
  const backToTop = document.getElementById('backToTop');

  const scrollToTarget = id => {
    const el = document.getElementById(id);
    if (el) {
      const y = el.getBoundingClientRect().top + window.scrollY - OFFSET;
      window.scrollTo({ top: y, behavior: 'smooth' });
      history.replaceState(null, null, ' '); // Remove hash from URL
    }
  };

  document.querySelectorAll('a[href*="#"]').forEach(a => {
    a.addEventListener('click', e => {
      const href = a.getAttribute('href');
      if (!href) return;
      const url = new URL(href, window.location.origin);
      const id = url.hash?.substring(1);
      if (!id) return;

      e.preventDefault();
      if (url.hostname === location.hostname &&
         (url.pathname === '/' || url.pathname === '/index.php' || url.pathname === location.pathname)) {
        scrollToTarget(id);
      } else {
        location.href = '/' + '#' + id; // navigate if on another page
      }
    });
  });

  // Handle hash on page load
  if (location.hash) scrollToTarget(location.hash.substring(1));

  // Back-to-top button visibility
  if (backToTop) {
    window.addEventListener('scroll', () => {
      backToTop.classList.toggle('visible', window.scrollY > 300);
    });
  }
});

// tab next prev btn text
document.addEventListener("DOMContentLoaded", function () {

  const tabButtons = document.querySelectorAll(".tab-button");
  const prevBtn = document.querySelector(".swiper-button-prev.tab span");
  const nextBtn = document.querySelector(".swiper-button-next.tab span");

  // Stop everything if tab buttons do not exist
  if (!tabButtons || tabButtons.length === 0) return;

  // Check navigation buttons
  if (!prevBtn || !nextBtn) {
    console.warn("Prev/Next button elements missing");
    return;
  }

  // SWIPER INSTANCE (content swiper)
  const contentSwiperEl = document.querySelector(".content-swiper");
  if (!contentSwiperEl) {
    console.warn("Content Swiper element missing");
    return;
  }

  const contentSwiper = contentSwiperEl.swiper;
  if (!contentSwiper) {
    console.warn("Swiper instance not found on .content-swiper");
    return;
  }

  function updatePrevNextText(activeIndex) {
    const total = tabButtons.length;

    if (!nextBtn || !prevBtn) return;

    // NEXT TAB NAME
    nextBtn.textContent =
      activeIndex < total - 1
        ? tabButtons[activeIndex + 1].textContent.trim()
        : "";

    // PREVIOUS TAB NAME
    prevBtn.textContent =
      activeIndex > 0
        ? tabButtons[activeIndex - 1].textContent.trim()
        : "";
  }

  // ---------- CLICK ON TAB ----------
  tabButtons.forEach((btn, index) => {
    btn.addEventListener("click", () => {
      if (!contentSwiper) return;
      contentSwiper.slideTo(index);
      updatePrevNextText(index);
    });
  });

  // ---------- SWIPE / SLIDE CHANGE ----------
  contentSwiper.on("slideChange", function () {
    updatePrevNextText(contentSwiper.activeIndex);
  });

  // ---------- INITIAL LOAD ----------
  updatePrevNextText(0);
});



// Starter Kit image slider PDP

// $(document).ready(function() {

//     new Swiper('.starter_kit_sec', {
//         loop: true,
//         nextButton: '.swiper-button-next',
//         prevButton: '.swiper-button-prev',
//         slidesPerView: 2,
//         paginationClickable: true,
//         spaceBetween: 20,
//         breakpoints: {
//             1920: {
//                 slidesPerView: 2,
//                 spaceBetween: 30
//             },
//             1028: {
//                 slidesPerView: 2,
//                 spaceBetween: 30
//             },
//             480: {
//                 slidesPerView: 1,
//                 spaceBetween: 10
//             }
//         }
//     });
// });


  document.addEventListener("DOMContentLoaded", function() {
    new Swiper(".starter_kit_sec", {
      slidesPerView: 4,
      spaceBetween: 5,
      loop: false,
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        320: {
          slidesPerView: 2
        },
        440: {
          slidesPerView: 3
        },
        500: {
          slidesPerView: 4
        },
        750: {
          slidesPerView: 3
        },
        1024: {
          slidesPerView: 4
        }
      }
    });
  });

// banner counter 


  // 👉 get values from DOM (tamara HTML mathi)
  document.addEventListener('DOMContentLoaded', function () {

  const dayEl = document.querySelector('.day-count');
  const hourEl = document.querySelector('.hour-count.counter');
  const minEl = document.querySelector('.minute-count');
  const secEl = document.querySelector('.second-count');

  let days = parseInt(dayEl?.getAttribute('data-day')) || 0;

  // Zieldatum aus der Section (data-target, JJJJ-MM-TT); sonst alte Logik „heute + Tage“
  const zielText = document.querySelector('.date-time-counter[data-target]')?.getAttribute('data-target');
  let targetDate = zielText ? new Date(zielText + 'T00:00:00') : null;
  if (!targetDate || isNaN(targetDate)) {
    targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + days);
    targetDate.setHours(23, 59, 59, 999); // end of last day
  }

  function updateUI() {
    const now = new Date();
    let diff = targetDate - now;

    if (diff <= 0) {
      if (dayEl) dayEl.textContent = 0;
      if (hourEl) hourEl.textContent = 0;
      if (minEl) minEl.textContent = 0;
      if (secEl) secEl.textContent = 0;
      return;
    }

    const d = Math.floor(diff / (1000 * 60 * 60 * 24));
    const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const m = Math.floor((diff / (1000 * 60)) % 60);
    const s = Math.floor((diff / 1000) % 60);

    if (dayEl) dayEl.textContent = d;
    if (hourEl) hourEl.textContent = h;
    if (minEl) minEl.textContent = m;
    if (secEl) secEl.textContent = s;
  }

  updateUI();
  setInterval(updateUI, 1000);

});